//上传资料

import { Component, Prop } from 'vue-property-decorator';
import { createNamespace } from 'src/util/bem';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import * as Vue from 'vue-tsx-support';
import { Integer, IViewDate } from 'src/types/base';
import EnumStationType from 'src/enums/enumStationType';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import { type } from 'os';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumAccessLevel from 'src/enums/enumAccessLevel';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';
import { Toast } from 'src/util/toast';
import Upload from 'src/types/iview/Upload';
import Input from 'src/types/iview/Input';
import DataManagementApi, {DataManagementDOI} from './api/dataManagementApi';
import DataManagement from './dataManagement';

export namespace DataManagementVOI {
    export interface PropsI {
        operate: string;
        id?: number;
        saveSuccess?(): void;
        cancel?(): void;
    }
    export interface FormDataI {
        id?: Integer;
        file_name: string;  //文件名称
        access_level: Integer; //访问级别
        data_id: Integer;  //文件类别
        data_url: string;  //文件存储路径
        type: string;  //水质类型
    }
}


@Component
class DataManagementModal extends Vue.Component<DataManagementVOI.PropsI> {
    
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    type: number;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    uploading: boolean = false;

    formData: DataManagementVOI.FormDataI = {
        file_name: '',
        access_level: null,
        data_id: 1,
        data_url: '',
        type: this.type,
    };

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            debugger
            this.formData.data_url=res.data.url;
            this.formData.file_name = res.data.name;
        } 
    }
    
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={'上传资料'}
                width="900"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >   
               <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="资料类型" prop="data_id" required type="number" style="display: inline-block;width:45%">
                      <EntitySelect type={EnumEntity.DataManagement.getId()} v-model={this.formData.data_id} />
                    </form-item>
                    <form-item label="访问级别" prop="access_level" required style="display: inline-block;width:45%"  type="number">
                        <CommonSelect dataSource={EnumAccessLevel.getList()} v-model={this.formData.access_level} />
                    </form-item>
                    <form-item label="上传附件"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/ops/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            before-upload={() => {
                                this.uploading = true;
                            }}
                        >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                        </Upload>
                        <div class={createNamespace('upload-text')}>支持扩展名：.rar .zip .doc .docx .pdf .jpg</div>
                    </form-item>
               </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }

    async save(){
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        this.loading = true;
        let params: DataManagementDOI.AddData = {
            ...this.formData
        };
        debugger
        let { code } = await DataManagementApi.add(params);
        
        this.loading = false;
        if (code === 0) {
            Toast.success('上传成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
}

export default function alertDataManagementModal(type: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<DataManagementVOI.PropsI>(DataManagementModal)({
            type,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}